import moment from 'moment';

function Ctrl($rootScope, $scope, $state, $stateParams, $location, $timeout, partnerService, jsSdkVenue, utilsService, loggerService) {
  $scope.loading = true;
  $scope.venues = [];

  $scope.citiesPromise
    .then(() => {
      const city = $stateParams.city;

      if (!city || city.length < 1) {
        $state.transitionTo('browse.venues', {
          city: utilsService.defaultCitySlug()
        });
        return;
      }

      $scope.changeCity($stateParams.city);
    });

  $scope.changeCity = function(citySlug) {
    // if (citySlug !== $stateParams.city) {
    //   $state.transitionTo('browse.venues', {
    //     city: citySlug
    //   });
    //   return;
    // }

    $scope.setCity(citySlug, function() {
      _getVenues();
    });
  };

  $scope.timeRanges = ['All Venues', 'Tonight', 'Tomorrow', 'This Weekend'];

  $scope.currentTimeRange = ($location.search() && $location.search().date) ? $location.search().date : 'All Venues';

  $scope.filterItemsByTime = function(venue) {
    const today = moment().day();

    if ($scope.currentTimeRange === 'All Venues') {
      return true;
    }

    if (!venue.schedule || venue.schedule.length === 0) {
      return false;
    } else if ($scope.currentTimeRange === 'Tonight') {
      return !venue.schedule[today].closed;
    } else if ($scope.currentTimeRange === 'Tomorrow') {
      return !venue.schedule[today + 1].closed;
    } else if ($scope.currentTimeRange === 'This Weekend') {
      return !venue.schedule[0].closed || !venue.schedule[5].closed || !venue.schedule[6].closed;
    }

    return false;
  };

  $scope.changeTimeRange = function(timeRange) {
    $location.search('date', timeRange);
    $scope.currentTimeRange = timeRange;
    $scope.updated();
  };

  $scope.filterItems = function(venue) {
    return $scope.filterItemsByTime(venue);
  };

  $scope.sorters = ['Featured', 'Alphabetical', 'Popular', 'Highest Rated'];

  $scope.sortBy = $location.search() && $location.search().sort ? $location.search().sort : 'Alphabetical';

  $scope.setSortBy = function(sorter) {
    $location.search('sort', sorter);
    $scope.sortBy = sorter;
    $scope.updated();
  };

  $scope.sortVenues = function(item) {
    if ($scope.sortBy === 'Featured') {
      return !item.featured;
    }

    if ($scope.sortBy === 'Popular') {
      return item.favoriteCount * -1;
    }

    if ($scope.sortBy === 'Alphabetical') {
      return item.name;
    }

    if ($scope.sortBy === 'Highest Rated') {
      return item.rating ? item.rating.ratingAverage * -1 : false;
    }

    return false;
  };

  function _getVenues() {
    $scope.loading = true;

    const options = {
      cityId: $scope.city.id,
      fields: 'name,seoPathname,tags,images,featured,rating,favoriteCount,schedule'
    };

    jsSdkVenue.listByCityId($scope.city.id, options).then(function success(response) {

      $scope.venues = response;

      $scope.loading = false;
      $scope.updated();

    }, function error(response) {
      loggerService.error(response);
      $scope.loading = false;
    });
  }

  $scope.updated = function() {
    $timeout(function() {
      $rootScope.$broadcast('venuesLoaded');
    });
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$stateParams',
  '$location',
  '$timeout',
  'partnerService',
  'jsSdk.venue',
  'utilsService',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/browseVenues/browseVenuesCtrl.js